var _defs, _rect, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrincess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000;stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 5.75,
    y: 5.31,
    width: 98.5,
    height: 98.91
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "104.25 5.31 92.86 33.84 84.01 54.77 75.79 75.91 75.79 92.61 34.27 92.61 34.27 75.76 25.45 54.31 17.04 33.86 5.75 5.31 34.83 17.26 76.15 33.84 92.86 33.84 92.7 75.91 75.79 75.91 55.22 84.32 34.27 92.69 5.75 104.22 16.97 75.35 34.24 33.79 75.79 16.94 104.25 5.31"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "34.34 17.06 75.86 17.06 75.86 34.07 92.7 75.91 104.25 104.22 75.79 92.61 55.22 84.32 34.27 75.76 16.82 75.75 17.04 33.86 34.24 33.79 34.34 17.06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincess);
export default __webpack_public_path__ + "static/media/princess.dffeba9d104a7c5a33585794e7282fdd.svg";
export { ForwardRef as ReactComponent };